import { ORGANIZATION_API_ENDPOINTS } from "@/features/auth/config/organizationApiPath";
import type { Organization, OrganizationResponse } from "@/features/auth/types/organization.type";
import { fetcher } from "@/shared/lib/fetcher.client";

export const getOrganization = async (organizationId: string, accessToken: string): Promise<Organization> => {
  const response = await fetcher.get<OrganizationResponse>(
    ORGANIZATION_API_ENDPOINTS.GET_ORGANIZATION(organizationId),
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );

  return response.data.organization;
};
